export const appendLineTooltip = (tbody, tooltips, label, classx) => {
  const tr_line = tbody.append("xhtml:tr");
  tr_line
    .append("xhtml:td")
    .style("text-align", tooltips.td.align.label)
    .style("color", tooltips.text.label.color)
    .style("font-size", `${tooltips.text.label.fontSize}px`)
    .style("font-weight", tooltips.text.label.fontWeight)
    .style("padding-left", `${tooltips.td.padding.label.left}px`)
    .style("padding-right", `${tooltips.td.padding.label.right}px`)
    .html(label);
  tr_line
    .append("xhtml:td")
    .style("color", tooltips.text.seperator.color)
    .style("font-size", `${tooltips.text.seperator.fontSize}px`)
    .style("font-weight", tooltips.text.seperator.fontWeight)
    .html(tooltips.tr.seperator);
  tr_line
    .append("xhtml:td")
    .style("text-align", tooltips.td.align.content)
    .style("color", tooltips.text.content.color)
    .style("font-size", `${tooltips.text.content.fontSize}px`)
    .style("font-weight", tooltips.text.content.fontWeight)
    .style("padding-left", `${tooltips.td.padding.content.left}px`)
    .style("padding-right", `${tooltips.td.padding.content.right}px`)
    .attr("class", classx)
    .html("");
};
